import React, { useState } from "react";
import "./Footer.css";
import { Nav, NavLink } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faEnvelope, faLocationDot, faPhone } from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Enquiry_Form_Modal from "../common_components/common_modal/Enquiry_Form_Modal/Enquiry_Form_Modal";
const Footer = () => {
  const [showModal, setShowModal] = useState(false)
  const location = useLocation();

  // const img_data = [
  //   { src: "/assets/images/footer/fb.png", link: "https://facebook.com" },
  //   { src: "/assets/images/footer/google.png", link: "https://google.com" },
  //   { src: "/assets/images/footer/twitter.png", link: "https://twitter.com" },
  //   { src: "/assets/images/footer/img4.png", link: "https://example.com" },
  // ];

  const our_programs = ["BBA", "MBA", "MCA", "MBA(WX)", "CPDM", "CPHAHM"]
  const pages = [
    // { name: "Contact", path: "/" },
    { name: "Committee", path: "https://www.dypatilonline.com/internal-complaints-committee.aspx" },
    { name: "Fee Structure", path: "https://www.dypatilonline.com/fee-structure.aspx" },
    { name: "Blog", path: "https://www.dypatilonline.com/blogs/" },
    { name: "Time Table", path: "https://www.dypatilonline.com/time-table.aspx" },
    { name: "Placement", path: "https://www.dypatilonline.com/placement.aspx" },
    { name: "Faculty", path: "http://dypatilonline.com/faculty.aspx" },
    { name: "About University", path: "https://www.dypatilonline.com/about-university.aspx" },
    { name: "Recognition & Approval", path: "https://www.dypatilonline.com/accreditation-and-affiliations.aspx" },
    { name: "Admissions Process", path: "https://www.dypatilonline.com/admissions.aspx" },
    { name: "Grievance Redressal", path: "https://col.dpuerp.in/login.aspx" },
    { name: "Privacy Policy", path: "https://www.dypatilonline.com/privacy-policy.aspx" },
    { name: "FAQ", path: "https://www.dypatilonline.com/admissions-faqs.aspx" },
  ];


  return (
    <>
      <section className="Footer">
        <div className="container">
          <p className="footer_desc_text_holder">"We display and
            showcase program information of Dr. DY. Patil Vidyapeeth's
            Centre for Online Learning (DPUCOL). Admission, program
            delivery, and examination are solely managed by DPUCOL.
            For any query related to the institute, student can visit our website."
          </p>
          <div className="row">

            <div className="col-lg-4 col-sm-12">

              <div className="col_div">
                <div className="logo_holder">
                  <img src="/assets/images/footer/logo.png" className="logo_img" />
                </div>
                <div className="address_holder">
                  <p className="title_text">Address:</p>
                  <p className="address">2nd Floor, Office No. 3, M No. 734, Opp High Class Society, Pashan Rd, near Suryadutta College, Patil Nagar, Bavdhan, Pune, Maharashtra 411021</p>
                </div>
              </div>

            </div>

            <div className="col-lg-4 col-sm-6">
              <div className="col_div">
                <p className="footer_section_title">Our Programs</p>
                <Nav>
                  <div className="first_nav_div">
                    {our_programs?.map((nav) => {
                      return (
                        <Nav.Item >
                          <NavLink onClick={() => { setShowModal(true) }}>
                            <FontAwesomeIcon icon={faAngleRight} /> {nav}
                          </NavLink>
                        </Nav.Item>
                      )
                    })}

                  </div>
                </Nav>

                {/* <div className="social_div">
                  <p className="footer_section_title">Connect With Us Socially,</p>
                  <div className="imgs_holder">
                    {img_data?.map((item, index) => (
                      <Link key={index} to={item.link} target="_blank">
                        <div className="logo_holder">
                          <img src={process.env.PUBLIC_URL + item.src} className="social_logo" alt="social" />
                        </div>
                      </Link>
                    ))}
                  </div>
                </div> */}

              </div>
            </div>

            {/* <div className="col-lg-4 col-sm-6">
              <div className="col_div">
                <p className="footer_section_title">Link</p>
                <Nav>
                  <div className="first_nav_div">
                    {pages?.map((page, index) => (
                      <Nav.Item key={index}>
                        <NavLink
                          as={Link}
                          to={page.path}
                          className={location.pathname === page.path ? "active" : ""}
                          target={page.path.startsWith("http") ? "_blank" : "_self"}
                        >
                          <FontAwesomeIcon icon={faAngleRight} /> {page.name}
                        </NavLink>
                      </Nav.Item>
                    ))}

                  </div>
                </Nav>

              </div>
            </div> */}

          </div>

          <div className="footer_text_div">
            <p className="footer_text">Our DPU Online MBA Course from Your City Location:</p>
            <p className="subtext">Delhi | Hyderabad | Ahmedabad | Bengaluru | Mumbai | Nagpur | Nashik | Surat</p>
          </div>

        </div >
      </section >

      <Enquiry_Form_Modal
        show={showModal}
        onHide={() => { setShowModal(false) }}
      />
    </>
  );
};

export default Footer;
